module.exports = __webpack_public_path__ + "img/link.0e08d433.jpg";